<div class="component-main-container">
  <div class="header">
    <app-page-header parentTitle="{{
      'unit-measurement.unit-measurement-parent-label' | translate
    }}" pageTitle="{{ 'unit-measurement.unit-measurement-page-label' | translate }}">
    </app-page-header>
  </div>
  <div class="row">
    <div class="col-lg-5 col-xl-4 col-sm-12">
      <div class="component-forms-box">
        <app-register-form></app-register-form>

        <div class="form-fields-box" [ngClass]="!register ? 'closed' : ''" [formGroup]="createForm">
          <h2 (click)="registerBox()">
            {{ "unit-measurement.register-unit-measurement" | translate }}
          </h2>
          <hr [ngClass]="!register ? 'hr-open' : ''" />
          <div class="form-step">
            <div class="circle-number">1</div>
            <mat-form-field appearance="outline">
              <mat-label>{{
                "unit-measurement.form-name" | translate
                }}</mat-label>
              <input matInput formControlName="reference" />
            </mat-form-field>
          </div>
          <div class="form-step">
            <div class="circle-number">2</div>
            <mat-form-field appearance="outline">
              <mat-label>{{
                "unit-measurement.form-symbol" | translate
                }}</mat-label>
              <input matInput formControlName="symbol" />
            </mat-form-field>
          </div>

          <button title="Salvar" class="btn btn-success" (click)="createUnits()">
            {{ "unit-measurement.button-save" | translate }}
          </button>
        </div>

        <div class="form-fields-box" [ngClass]="!filter ? 'closed' : ''" [formGroup]="filterForm">
          <h2 (click)="filterBox()">
            {{ "unit-measurement.filter-unit-measurement" | translate }}
          </h2>
          <hr [ngClass]="!filter ? 'hr-open' : ''" />

          <div class="form-step">
            <div class="circle-number">1</div>
            <mat-form-field appearance="outline">
              <mat-label>{{
                "unit-measurement.form-name" | translate
                }}</mat-label>
              <input matInput formControlName="reference" />
            </mat-form-field>
          </div>
          @if (filterLoading) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
          @if (!filterLoading) {
          <button title="Filtrar" class="btn btn-success" (click)="filterUnits(null)">
            {{ "unit-measurement.button-filter" | translate }}
          </button>
          }
        </div>
      </div>
    </div>

    <!-- Sessão tabela -->
    @if (ELEMENT_DATA.length) {
    <div class="col-lg-7 col-xl-8 col-sm-12">
      <app-table-header [itensNumber]="paginationProperties.count" [totalNumber]="paginationProperties.total"
        [hasCSV]="true" [hasPDF]="true" (downloadCSV)="generateFileData(null, 'CSV')"
        (downloadPDF)="generateFileData(null, 'PDF')" [loadingData$]="fileLoading">
      </app-table-header>
      <div class="table-container mt-2 mt-lg-3 mt-xl-3">
        <p-table [value]="ELEMENT_DATA" [rows]="pageSize" [totalRecords]="length" dataKey="id" [paginator]="true"
          (onPage)="pageChanged($event)" [showPageLinks]=" false" [showFirstLastIcon]="false" [lazy]="true">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="name"> {{ "unit-measurement.form-name" | translate }}</th>
              <th pSortableColumn="symbol"> {{ "unit-measurement.form-symbol" | translate }}</th>
              <th pSortableColumn="action"> {{ "unit-measurement.actions-table" | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
            <tr>
              <td>{{row.name}}</td>
              <td>{{row.symbol}}</td>
              <td>

                <p-button styleClass="btn-actions" [rounded]="true" (click)="OpenUpdateSideBar(row)"
                  icon="pi pi-pen-to-square" />
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    }
  </div>

  <!--Sidebar edit-->
  @if (openSideBar) {
  <div class="sidebar-edit" [formGroup]="updateForm">
    <mat-icon (click)="openSideBar = false">clear</mat-icon>
    <h2>{{"unit-measurement.edit-unit-measurement" | translate}}</h2>
    <hr>
    <mat-form-field appearance="outline">
      <mat-label>{{ "unit-measurement.form-name" | translate }}</mat-label>
      <input matInput formControlName="reference" />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>{{ "unit-measurement.form-symbol" | translate }}</mat-label>
      <input matInput formControlName="symbol" />
    </mat-form-field>
    <button class="btn btn-success" (click)="updateUnits()">{{"unit-measurement.button-edit" | translate}}</button>
  </div>
  }
</div>